import * as actionTypes from '../actions/actionTypes'

const initialState = {
  realex: {},
  stripe: {},
  showModalReceipt: false,
  showModalPlaceOrder: false,
  showModalError: false,
  messageError: '',
  messageSuccess: '',
  intervalReference: undefined,
  realexFormSize: {
    width: '100%',
    height: '950',
  },
}

const checkoutReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.REALEX_CONFIG_DATA_LOADED:
      return {
        ...state,
        realex: {
          ...payload,
        },
      }
    case actionTypes.STRIPE_CONFIG_DATA_LOADED:
      return {
        ...state,
        stripe: {
          ...payload,
        },
      }
    case actionTypes.CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_RECEIPT:
      return {
        ...state,
        showModalReceipt: payload,
      }
    case actionTypes.CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_ERROR:
      return {
        ...state,
        showModalError: payload.show,
        messageError: payload.messageError
      }
    case actionTypes.CHECKOUT_REALEX_TOGGLE_SHOW_MODAL_PLACE_ORDER:
      return {
        ...state,
        showModalPlaceOrder: payload.show,
        messageSuccess: payload.messageSuccess
      }
    case actionTypes.CHECKOUT_SET_INTERVAL_REFERENCE:
      return {
        ...state,
        intervalReference: payload,
      }
    case actionTypes.CHECKOUT_RESIZE_REALEX_FORM:
      return {
        ...state,
        realexFormSize: payload,
      }
    case actionTypes.CHECKOUT_RESET_STATE:
      clearInterval(state.intervalReference)
      return initialState
    default:
      return state
  }
}

export default checkoutReducer



// WEBPACK FOOTER //
// ./src/store/reducers/checkoutReducer.js